import PropTypes from 'prop-types';

import { questionPropType } from 'components/productdetail/ask/commonAskPropTypes';
import Answer from 'components/productdetail/ask/Answer';
import ItemForm from 'components/productdetail/ask/ItemForm';
import css from 'styles/components/productdetail/ask/answerList.scss';

const AnswerList = ({ authenticated, question: { answering, answers, answersCollapsed , key: questionKey },
  onAddAskDownvote, onAddAskUpvote, onReportAskAnswer, onSetAnsweringAskQuestion, onSetAskAnswersCollapsed, onAskAuthRedirect, onSubmitAskItem }) => {
  const answerEls = answers.map(a => (
    <Answer
      key={a.key}
      answer={a}
      onAddAskDownvote={onAddAskDownvote}
      onAddAskUpvote={onAddAskUpvote}
      onReportAskAnswer={onReportAskAnswer} />
  ));
  const collapsibleMarkup = !answersCollapsed ? <div>{answerEls.slice(1)}</div> : null;
  const seeOrHide = answersCollapsed ? 'See' : 'Hide';
  let collapserMarkup = null;
  if (answerEls.length > 1) {
    collapserMarkup = (
      <button type="button" className={css.seeAllAnswers} onClick={onSetAskAnswersCollapsed.bind(null, questionKey, !answersCollapsed)}>
        {seeOrHide} All Answers
      </button>
    );
  }

  const placeholder = answerEls.length === 0 ? 'Be the first to answer this question!' : 'Respond to this question';
  let answeringSection;
  if (answering || answerEls.length === 0) {
    answeringSection = <ItemForm
      onAskAuthRedirect={onAskAuthRedirect}
      onSubmitAskItem={onSubmitAskItem}
      questionKey={questionKey}
      textareaPlaceholder={placeholder}
      authenticated={authenticated} />;
  } else {
    const openAnswerDialog = () => onSetAnsweringAskQuestion(questionKey, true);
    answeringSection = (
      <button type="button" className={css.buttonToAnswerQuestion} onClick={openAnswerDialog}>
        Submit Answer
      </button>
    );
  }

  return (
    <div>
      {answerEls[0]}
      {collapserMarkup}
      {collapsibleMarkup}
      {answeringSection}
    </div>
  );
};

AnswerList.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  question: questionPropType,
  onAddAskDownvote: PropTypes.func.isRequired,
  onAddAskUpvote: PropTypes.func.isRequired,
  onReportAskAnswer: PropTypes.func.isRequired,
  onSetAnsweringAskQuestion: PropTypes.func.isRequired,
  onSetAskAnswersCollapsed: PropTypes.func.isRequired,
  onAskAuthRedirect: PropTypes.func.isRequired,
  onSubmitAskItem: PropTypes.func.isRequired
};

export default AnswerList;
